import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { LocalBalance } from '../../../views/widgets/walletCard/types'

export type WalletItem = {
  id: string
  name: string
  localBalances: LocalBalance[]
}

export type WalletsResponse = {
  items: WalletItem[]
  total: number
}

export const walletsMounted = createEvent()

export const getWallets = fx<void, WalletsResponse>({
  method: 'GET',
  url: `/finance/wallet`,
})

export const $wallets = restore<WalletItem[]>(
  getWallets.doneData.map((a) => a.body.items),
  [],
)

// Пока справочник не загружен, фильтр по кошелькам знает только id из URL —
// показывать их пользователю не нужно
export const $walletsLoaded = restore<boolean>(
  getWallets.finally.map(() => true),
  false,
)

sample({
  clock: walletsMounted,
  fn: () => ({}),
  target: getWallets,
})
